"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.positionHistorySelector = exports.openPositionsSelector = exports.isLoadingOpenPositionsSelector = exports.getSelectedInstrumentPositionSelector = exports.futuresOpenPositionsCountSelector = void 0;
var _reselect = require("reselect");
var _futuresInstrumentsSelector = require("./futuresInstrumentsSelector");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var selectPositionsState = function selectPositionsState(state) {
  return state.futures.positions;
};
var openFuturesPositionsSelector = (0, _reselect.createSelector)(selectPositionsState, function (state) {
  return state.openPositions;
});
var futuresPositionHistorySelector = (0, _reselect.createSelector)(selectPositionsState, function (state) {
  return state.positionHistory;
});
var isLoadingOpenPositionsSelector = exports.isLoadingOpenPositionsSelector = (0, _reselect.createSelector)(selectPositionsState, function (state) {
  return state.isLoadingOpenPositions;
});
function transformPositions(positions, products, instruments) {
  return positions.map(function (position) {
    var baseProduct = products.find(function (p) {
      return position.BaseProductId === p.ProductId;
    });
    var quoteProduct = products.find(function (p) {
      return position.QuoteProductId === p.ProductId;
    });
    var instrument = instruments.find(function (i) {
      return i.InstrumentId === position.InstrumentId;
    });
    return _objectSpread(_objectSpread({}, position), {}, {
      BaseProductSymbol: baseProduct === null || baseProduct === void 0 ? void 0 : baseProduct.Product,
      QuoteProductSymbol: quoteProduct === null || quoteProduct === void 0 ? void 0 : quoteProduct.Product,
      instrument: instrument,
      baseProduct: baseProduct,
      quoteProduct: quoteProduct
    });
  });
}
var openPositionsSelector = exports.openPositionsSelector = (0, _reselect.createSelector)(openFuturesPositionsSelector, function (state) {
  return state.apexCore.product.products;
}, _futuresInstrumentsSelector.futuresInstrumentsSelector, function (positions, products, instruments) {
  return transformPositions(positions, products, instruments).sort(function (a, b) {
    return new Date(b.DateOpened).valueOf() - new Date(a.DateOpened).valueOf();
  });
});
var futuresOpenPositionsCountSelector = exports.futuresOpenPositionsCountSelector = (0, _reselect.createSelector)(openFuturesPositionsSelector, function (positions) {
  return positions.length || 0;
});
var getSelectedInstrumentPositionSelector = exports.getSelectedInstrumentPositionSelector = (0, _reselect.createSelector)([openPositionsSelector, _futuresInstrumentsSelector.futuresSelectedInstrumentIdSelector], function (positions, instrumentId) {
  return positions.find(function (position) {
    return position.InstrumentId === instrumentId;
  }) || null;
});
var positionHistorySelector = exports.positionHistorySelector = (0, _reselect.createSelector)(futuresPositionHistorySelector, function (state) {
  return state.apexCore.product.products;
}, _futuresInstrumentsSelector.futuresInstrumentsSelector, function (positionHistory, products, instruments) {
  return transformPositions(positionHistory, products, instruments).sort(function (a, b) {
    return new Date(b.DateOpened).valueOf() - new Date(a.DateOpened).valueOf();
  });
});